module.exports = __webpack_public_path__ + "img/ryzs8.e5703edf.jpg";